module.exports = __webpack_public_path__ + "img/97.088f8372.jpg";